import Button from "src/components/button/Button";
import SelectorWrapper from "src/components/selectorwrapper/SelectorWrapper";
import OptionsProps from "src/components/streaming/findsomethingtostream/OptionsProps";
import { SControls, SFilterBlock, SLabelledCheck, SScrollContainer } from "src/components/streaming/findsomethingtostream/OptionsStyles";
import { StreamingProvider } from "src/lib/movieinfo/movieinfotypes";
import { uniq } from "lodash";
import { Dispatch, SetStateAction, useState } from "react";

//#region [Props]
type OptionsProvidersProps = {
	providers: StreamingProvider[];
} & OptionsProps;
//#endregion

//#region [Component]
export default function OptionsProviders({ filterDispatch, filterState, providers }: OptionsProvidersProps) {
	const [selectedProviders, setSelectedProviders] = useState(filterState.providers);

	return <SelectorWrapper onClose={() => filterDispatch({ type: "hideOptions" })}>
		<SScrollContainer>
			<SFilterBlock>
				<SLabelledCheck selected={selectedProviders.length === 0}
					value="Alle"
					selectionCallback={() => setSelectedProviders([])}
				/>
				{providers.map(provider => <SLabelledCheck key={provider.id}
					value={provider.id}
					label={provider.name!}
					selected={selectedProviders.includes(provider)}
					selectionCallback={isSelected => selectProvider(setSelectedProviders, selectedProviders, isSelected, provider)}
				/>)}
			</SFilterBlock>
		</SScrollContainer>
		<SControls>
			<Button text="Vis" onClick={() => filterDispatch({ type: "setProviders", providers: selectedProviders })} />
			<Button text="Avbryt" onClick={() => filterDispatch({ type: "hideOptions" })} />
		</SControls>
	</SelectorWrapper>
}
//#endregion

function selectProvider(setSelectedProviders: Dispatch<SetStateAction<StreamingProvider[]>>, currProviders: StreamingProvider[], isSelected: boolean, value: StreamingProvider) {
	if (isSelected) {
		setSelectedProviders(uniq([...currProviders, value]));
	} else {
		setSelectedProviders(currProviders.filter(g => g !== value));
	}
}

//#region [Styles]

//#endregion